import { Component, OnInit, ViewEncapsulation, ComponentFactoryResolver, ApplicationRef, Injector, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import { AppSettings } from '../../../app.settings';
import { ToastrService } from 'ngx-toastr';
import { Settings } from '../../../app.settings.model';
import { MenuService } from '../menu/menu.service';
import { AuthService } from '../../../shared/services/auth.service';
import { sideNavService } from '../sidenav/sidenav.service';
import { SocketService } from '../../../shared/services/socket.service';
import { Router } from '@angular/router';
import { ChatService } from '../../../pages/chat/chat.service';
import { PreviewDialogComponent } from '../../../shared/components/preview-dialog/preview-dialog.component';
import { MatDialog } from '@angular/material';
import { PagesComponent } from '../../../pages/pages.component';
import { ChatP } from '../../../pages/chat/chat.model';
import { UtilsUmsService } from '../../../shared/services/utils.ums.service';
import { GeneralService } from '../../../shared/services/general.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ MenuService, ChatService, sideNavService]
})
export class SidenavComponent implements OnInit, AfterViewInit {
  // public countChatMessage: number = 0;
  @Input()
    public countChatMessage: number = 0;
  public user = AuthService.getUser();
  public userPhoto = '../assets/img/avatars/' + this.user.photo;
  public menuItems: Array<any>;
  public settings: Settings;
  public lastLogin: string;
  public portalTitle: string;
  private socketService = SocketService.getInstance();
  public role :number;
  public up:number=1;
  public AuthService:AuthService;
  @Output() public onMessageReceived: EventEmitter<ChatP> = new EventEmitter<ChatP>();
  public stacatalu: string = '';

  constructor(public router: Router, public appSettings:AppSettings, public menuService: MenuService, private chatService: ChatService,public sideNavService:sideNavService,
    public dialog: MatDialog,
    public toastr:ToastrService,
    public utils: UtilsUmsService,
    private generalService: GeneralService
    // private componentFactoryResolver: ComponentFactoryResolver,
    // private applicationRef: ApplicationRef,
    // private injector: Injector
  ) {
      this.settings = this.appSettings.settings;
      this.role     = AuthService.getUser().role.id;
  }

  ngAfterViewInit() {
    // const componentRef = this.componentFactoryResolver.resolveComponentFactory(PagesComponent).create(this.injector);        
    
    //   this.applicationRef.attachView(componentRef.hostView);
      
    //   let instance = <PagesComponent>componentRef.instance;

    //   instance.onMessageReceived.subscribe(message => {
    //     console.log(message);
    //   });
  }

  doSome(count: number) {
    this.countChatMessage = count;
  }

  ngOnInit() {
    // this.menuItems = this.menuService.getVerticalMenuItems();
    this.generalService.getStudentInfo(this.user.business_id, this.user.registration).subscribe((result) => {
      this.stacatalu = result.info.stacatalu;
    })

    this.onMessageReceived.subscribe(x => {
      console.log(x);
    });

    this.lastLogin = AuthService.getLastLogin();
    this.portalTitle = window.location.hostname.search("alumnos") != -1 ? 'Alumnos'
                    : (window.location.hostname.search("escolar") != -1 ? 'Escolar'
                    : (window.location.hostname.search("profesores") != -1 ? 'Profesores'
                    : 'AdminPortal'));

  if(this.router.url != '/chat') {
    this.chatService.getChats(AuthService.getUser().id).subscribe(chats => {
      chats.filter(x => {
        this.countChatMessage += x.countNewMessage;
      });
    });
  }
                        
    this.socketService.onNewChatMessage().subscribe(message => {
        console.log('SIDENAVBAR');

        // if(this.router.url != '/chat') {
        //   let count = 0;

        //   AuthService.chats.filter(x => {
        //     count += x.countNewMessage;
        //   });

        //   this.countChatMessage = count;
        // }

    });

  }

  public closeSubMenus(){
    let menu = document.querySelector(".sidenav-menu-outer");
    if(menu){
      for (let i = 0; i < menu.children[0].children.length; i++) {
        let child = menu.children[0].children[i];
        if(child){
          if(child.children[0].classList.contains('expanded')){
              child.children[0].classList.remove('expanded');
              child.children[1].classList.remove('show');
          }
        }
      }
    }
  }

  public onLoggedOut() {
    AuthService.loggedOut();
  }

   unlock(){
    this.sideNavService.unlock(this.up).subscribe(x=>{
    });
    this.toastr.success('Cuentas Desbloqueadas');
  }

  openDialogPreview() {
      let dialogRef = this.dialog.open(PreviewDialogComponent, {
          // panelClass: 'custom-dialog-container',
          // width: '50%',
          // height: '95%',
          data: {src: 'assets/img/avatars/' + AuthService.getUser().photo}
      });
  
      dialogRef.afterClosed().subscribe(result => {
      });
  }

}
